import { schemaDefault } from '../../SchemaDefault';

export default {
  measure: schemaDefault.strict(),
};
